var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contribution-event-base',{attrs:{"event":_vm.event,"message":_vm.$options.i18n.message,"icon-name":"merge-request"}})
}
var staticRenderFns = []

export { render, staticRenderFns }